import React from 'react'
import { ToastContainer, toast } from 'react-toastify'

type Props = {}

const TimeOut = (props: Props) => {
    toast.error('Please Refresh Page')
    return (
        <div>
            <ToastContainer />
            <h1 style={{ textAlign: "center" }}>There was an error, please refresh the page and try again</h1>
        </div>
    )
}

export default TimeOut